/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import "firebase/compat/auth";
import "firebase/compat/database";
import { createStyles } from "@material-ui/core/styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Button } from "components/atoms/button/Button";
import { useI18n } from "hooks/i18n/i18n";

import type { StyleRules } from "@material-ui/core/styles/withStyles";

const styles: StyleRules = createStyles({
  buttonRoot: {
    width: "80vw",
    margin: "10px",
    color: "#fff",
    backgroundColor: "#000",
  },
});

type Props = {
  isSignup: boolean;
  onClick: () => void;
};
const FanyIdLoginButton = ({ isSignup, onClick }: Props) => {
  const { t } = useI18n();
  const actionText = isSignup
    ? t("login.buttons.registration")
    : t("login.buttons.login");

  return (
    <Button
      text={`${t("login.loginMethod.fanyid")}${actionText}`}
      color={"#1976d2"} // TODO 仮で設定しているので決まったらカラー変更する
      onClick={onClick}
    />
  );
};

export default withStyles(styles)(FanyIdLoginButton);
